import { useTranslation } from 'react-i18next'

function Testimonial() {
  const { t } = useTranslation()

  return (
    <section className="w-full bg-sage py-40 px-20 tablet:px-32">
      <div className="max-w-lg mx-auto">
        <p className="text-lato-italic text-white text-3xl leading-relaxed mb-10">
          {t('pages.home.sections.testimonial.text')} - {t('pages.home.sections.testimonial.author')}
        </p>
      </div>
    </section>
  )
}

export default Testimonial
